import PropTypes from 'prop-types';
import React from 'react';
export var ProfileViewDetail = function ProfileViewDetail(_ref) {
  var children = _ref.children,
    label = _ref.label,
    labelTestId = _ref.labelTestId,
    value = _ref.value,
    valueTestId = _ref.valueTestId,
    columnWidth = _ref.columnWidth;
  if (children && value) {
    console.warn('ProfileViewDetail: children and value are mutually exclusive props');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "col-sm-".concat(columnWidth)
  }, /*#__PURE__*/React.createElement("p", {
    className: "italic text-xs mb-1",
    "data-testid": labelTestId
  }, label), children ? children : /*#__PURE__*/React.createElement("p", {
    "data-testid": valueTestId
  }, value));
};
ProfileViewDetail.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string.isRequired,
  labelTestId: PropTypes.string,
  value: PropTypes.string,
  valueTestId: PropTypes.string,
  columnWidth: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
};
ProfileViewDetail.defaultProps = {
  children: undefined,
  labelTestId: undefined,
  value: undefined,
  valueTestId: undefined,
  columnWidth: 4
};
//# sourceMappingURL=ProfileViewDetail.js.map